var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewamericanFundingLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 714.87 138.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }         \r\n      .cls-2{\r\n        fill:#091644;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NAF_Logo_-_Colored",
    "data-name": "NAF Logo - Colored"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    className: "cls-1",
    width: 138.18,
    height: 138.18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    className: "cls-2",
    d: "m46.85,69.49c0-6.17-3.4-9.53-8.55-9.53s-8.68,3.36-8.68,9.53v21.3h-9.76v-38.57h9.76v4.79c2.83-3.51,7.13-5.5,11.63-5.37,8.99,0,15.39,5.86,15.39,16.51v22.64h-9.76v-21.3h-.04s0,0,.01,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-2",
    d: "m76.7,51.68c4.99-.17,9.74,2.12,12.71,6.13v-5.5h9.8v38.52h-9.8v-5.64c-2.95,4.1-7.75,6.45-12.8,6.27-9.76,0-17.54-8.01-17.54-20.05.05-12.04,7.83-19.74,17.63-19.74h0Zm2.51,8.55c-5.23,0-10.16,3.9-10.16,11.19s4.92,11.46,10.16,11.46,10.25-4.03,10.25-11.32-4.88-11.32-10.25-11.32h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-2",
    d: "m111.64,52.4v-1.61c0-4.3,1.61-5.82,6.31-5.68h.4v-8.18h-.58c-10.69-.23-15.97,4.16-15.97,13.51v40.36h9.84v-30.43h6.71v-7.96h-6.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-1",
    d: "m361.06,42.51c1.03,2.11,1.51,4.45,1.39,6.8-.04,2.38-.58,4.73-1.6,6.89-2.47,5.72-8.18,9.36-14.41,9.17-11.5,0-15.97-9.8-16.06-16.11-.3-8.67,6.48-15.94,15.15-16.24h.77c6.43-.27,12.34,3.52,14.77,9.49m1.3-9.84c-3.81-5.73-10.35-9.04-17.23-8.73-13.92,0-24.48,10.83-24.48,25.24,0,12.62,8.41,25.33,24.48,25.33,6.86.3,13.38-2.99,17.23-8.68v7.29h9.62V25.28h-9.62v7.38h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-1",
    d: "m431.93,23.94c-4.74-.1-9.31,1.71-12.71,5.01-1.21,1.3-2.28,2.72-3.18,4.25l-.05-.13c-.74-1.42-1.64-2.76-2.69-3.98-3.2-3.45-7.74-5.33-12.44-5.15-5.54-.08-10.77,2.58-13.96,7.11v-5.73h-9.12v47.79h9.62v-26.13c-.14-3.34.73-6.65,2.51-9.49,1.87-2.9,5.14-4.6,8.59-4.47h.05c3.48-.17,6.78,1.58,8.59,4.56,1.53,2.78,2.19,5.97,1.88,9.13v26.31h9.76v-26.32c-.3-3.26.43-6.53,2.1-9.35,1.96-2.91,5.31-4.56,8.81-4.34,3.21-.27,6.33,1.17,8.19,3.8,1.74,2.24,2.51,5.5,2.51,10.25v25.96h9.67v-26.31c0-9.49-1.25-13.87-5.28-17.99-3.47-3.24-8.09-4.97-12.84-4.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-1",
    d: "m479.63,32.26h.36c7.37-.1,13.71,5.21,14.9,12.48h-30.47c1.11-7.45,7.69-12.85,15.21-12.48m0-8.32c-13.96.02-25.26,11.36-25.24,25.33.02,13.96,11.36,25.26,25.33,25.24,4.85.04,9.61-1.38,13.64-4.07,4.33-2.88,7.7-6.99,9.67-11.81l.23-.45h-10.06l-.13.18c-2.55,4.97-7.75,8.01-13.33,7.79-7.07,0-14.9-4.79-15.44-13.69h40.23l.05-.31c.95-7.78-1.7-15.57-7.2-21.17-4.73-4.62-11.11-7.15-17.72-7.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-1",
    d: "m517.98,31.23v-5.95h-9.17v47.79h9.67v-25.77c0-9.13,4.21-13.69,12.57-13.69h.9v-9.71h-.36c-5.54-.25-10.77,2.57-13.6,7.34"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    className: "cls-1",
    x: 537.85,
    y: 24.12,
    width: 9.62,
    height: 10.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    className: "cls-1",
    x: 537.85,
    y: 40.5,
    width: 9.62,
    height: 32.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-1",
    d: "m689.13,23.94h-.27c-6.98,0-12.48,2.77-15.39,7.65v-6.31h-9.17v47.79h9.67v-26.58c0-8.59,4.52-13.33,12.8-13.47,7.92,0,11.95,4.74,11.95,14.14v25.91h9.8v-27.93c.05-7.88-2.51-21.03-19.38-21.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-1",
    d: "m647.3,56.2c-2.46,5.7-8.15,9.34-14.36,9.17-11.63,0-16.06-9.8-16.11-16.11-.27-8.7,6.56-15.97,15.26-16.24h.71c6.43-.23,12.33,3.57,14.77,9.53,1,2.12,1.46,4.46,1.34,6.8-.08,2.36-.62,4.69-1.6,6.85m1.52-30.92v7.34c-3.83-5.69-10.33-8.99-17.18-8.73-7.35-.1-14.35,3.18-18.97,8.9l-.05-.05-19.73,23.05-2.95,3.45c-.17.26-.36.5-.58.71-2.99,3.49-7.39,5.46-11.99,5.37-8.64.09-15.71-6.84-15.8-15.48v-.71c-.06-4.32,1.54-8.5,4.47-11.67,2.89-2.94,6.84-4.59,10.96-4.56l.36.05c6.36-.21,12.14,3.66,14.36,9.62l.13.23h.05l6.54-7.65c-7.82-11.48-23.46-14.45-34.93-6.63-11.48,7.82-14.45,23.46-6.63,34.93,7.82,11.48,23.46,14.45,34.93,6.63.76-.52,1.5-1.08,2.2-1.68h0c1.17-.99,2.23-2.1,3.18-3.31l8.5-9.76,1.7-1.92c1.66,11.05,9.89,21.08,24.16,21.08,6.85.31,13.36-2.98,17.18-8.68v7.29h9.67V25.29h-9.58,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-1",
    d: "m183.15,24.7h-.27c-6.85,0-12.26,2.73-15.08,7.57v-6.18h-9v47.07h9.53v-26.22c0-8.46,4.43-13.15,12.62-13.24,7.83,0,11.77,4.7,11.77,13.96v25.51h9.62v-27.56c-.09-7.7-2.55-20.72-19.2-20.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-1",
    d: "m230.8,32.93h.31c7.24-.13,13.49,5.07,14.68,12.21h-29.98c.58-6.04,6.27-12.21,14.99-12.21m0-8.23c-13.75.01-24.89,11.17-24.88,24.92s11.17,24.89,24.92,24.88h0c4.77.05,9.45-1.34,13.42-3.98,4.25-2.86,7.57-6.9,9.53-11.63l.18-.45h-9.89l-.04.13c-2.53,4.89-7.65,7.89-13.16,7.7-7.03,0-14.68-4.7-15.26-13.51h39.65l.04-.36c.98-7.66-1.65-15.35-7.11-20.81-4.66-4.51-10.92-6.99-17.41-6.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-1",
    d: "m252.68,26.09h9.31l10.83,27.03,15.21-28.41h.45l14.63,28.59,10.78-27.25h9.31l-18.34,46.8h-.58l-16.11-31.94-16.42,31.99h-.58l-18.48-46.8h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-1",
    d: "m178.5,85.55v4.39h-13.96v9.71h10.87v4.39h-10.87v14.41h-5.41v-32.89h19.38,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    className: "cls-1",
    d: "m203.24,85.55v20.98c-.46,3.69,2.16,7.05,5.84,7.51.53.07,1.06.07,1.58,0,2.01.13,3.99-.55,5.5-1.88,1.41-1.53,2.12-3.57,1.97-5.64v-20.98h5.37v20.9c.08,2.39-.53,4.75-1.74,6.8-1.11,1.83-2.75,3.28-4.7,4.16-2.04.93-4.25,1.4-6.49,1.39-2.23.04-4.43-.44-6.44-1.39-1.92-.88-3.53-2.34-4.6-4.16-1.18-2.07-1.77-4.42-1.7-6.8v-20.9h5.42,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    className: "cls-1",
    d: "m271.92,118.44h-5.41l-16.24-24.56v24.57h-5.41v-32.94h5.41l16.24,24.52v-24.52h5.41s0,32.93,0,32.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    className: "cls-1",
    d: "m313.31,87.57c2.56,1.27,4.68,3.28,6.09,5.77,1.47,2.68,2.21,5.71,2.15,8.77.08,3.05-.66,6.06-2.15,8.72-1.43,2.44-3.54,4.4-6.09,5.64-2.88,1.36-6.03,2.04-9.22,1.97h-10.74v-32.89h10.74c3.19-.07,6.35.62,9.22,2.01h0Zm-.36,23.36c2.06-2.1,3.09-5.01,3.09-8.82s-1.03-6.8-3.09-8.95-5.01-3.22-8.86-3.22h-5.37v24.11h5.37c3.85,0,6.8-1.03,8.86-3.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    className: "cls-1",
    d: "m346.65,85.55v32.89h-5.41v-32.89h5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    className: "cls-1",
    d: "m395.15,118.44h-5.41l-16.24-24.56v24.57h-5.41v-32.94h5.41l16.24,24.52v-24.52h5.41s0,32.93,0,32.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    className: "cls-1",
    d: "m440.4,95.04c-.77-1.57-2.01-2.86-3.54-3.71-1.61-.86-3.41-1.3-5.23-1.25-2.04-.04-4.05.47-5.82,1.48-1.7.98-3.08,2.42-3.98,4.16-1,1.93-1.49,4.09-1.43,6.27-.04,2.17.45,4.32,1.43,6.27.9,1.75,2.28,3.21,3.98,4.21,1.77,1.01,3.78,1.52,5.82,1.48,2.61.12,5.17-.76,7.16-2.46,1.89-1.74,3.08-4.11,3.36-6.67h-12.35v-4.39h18.12v4.21c-.71,5.19-3.85,9.73-8.46,12.22-2.4,1.3-5.1,1.96-7.83,1.92-2.96.03-5.87-.71-8.46-2.15-2.53-1.42-4.63-3.49-6.09-6-1.53-2.63-2.3-5.64-2.24-8.68-.04-3.04.74-6.04,2.24-8.68,1.45-2.52,3.55-4.59,6.09-6,5.6-3.02,12.37-2.85,17.81.45,2.73,1.72,4.82,4.28,5.95,7.29h-6.54v.05-.02h.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6953",
    "data-name": "Path 6953",
    className: "cls-1",
    d: "m707.39,16.67h-1.96v5.33h-1.32v-5.33h-1.93v-1.07h5.21v1.07Zm2.47-1.07l1.64,4.64,1.64-4.64h1.73v6.4h-1.32v-1.75l.13-3.02-1.73,4.77h-.91l-1.72-4.76.13,3.02v1.75h-1.32v-6.4h1.73,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewamericanFundingLogoWhite);
export default __webpack_public_path__ + "static/media/newamerican-funding-logo-white.81ef0af15a31daf3331c180f5446b3a6.svg";
export { ForwardRef as ReactComponent };